import { ifElse, isNil } from 'rambda';

export const safeEvolveProp = <T, U>(mapFn: (a: T) => U) =>
  ifElse(isNil, () => undefined, mapFn);
